module.exports = "<div class=\"toolbar\">\n    <button>Download</button>\n    <button (click)=\"run()\">Run</button>\n</div>\n\n<ngx-monaco-editor [options]=\"editorOptions\" [(ngModel)]=\"code\" (onInit)=\"onInit($event)\"></ngx-monaco-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/left-pane/left-pane.component.html
// module id = ./src/app/components/left-pane/left-pane.component.html
// module chunks = main